const companiesActionTypes = {
  FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION: 'FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION',
  FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_SUCCESS: 'FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_SUCCESS',
  FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_FAIL: 'FETCH_ADD_OR_EDIT_COMPANY_SUBMISSION_FAIL',
};

export default companiesActionTypes;
